import { Outlet } from "react-router-dom";

import { ToastProvider } from "@smart/bridge-intake-components-dom";
import { SmokeballProvider } from "@smart/itops-smokeball-app-dom";
import { Debug } from "@smart/itops-smokeball-components-dom/src/debug";
import {
  ActAsProvider,
  AnalyticsEventProvider,
  ClientProvider,
  EventCapturer,
  IntercomProvider,
  UserProvider,
} from "@smart/manage-hooks-dom";

import { CaptureDemoMode } from "./capture-demo-mode";
import { DemoGate } from "./demo-gate";

const Embedded = () => (
  <DemoGate>
    <SmokeballProvider observe={["matters", "layouts", "contacts", "staff"]}>
      <CaptureDemoMode />
      <UserProvider isEmbeddedPage>
        <IntercomProvider>
          <ClientProvider>
            <AnalyticsEventProvider>
              <EventCapturer>
                <ToastProvider>
                  <ActAsProvider>
                    <Outlet />
                  </ActAsProvider>
                </ToastProvider>
              </EventCapturer>
              <Debug />
            </AnalyticsEventProvider>
          </ClientProvider>
        </IntercomProvider>
      </UserProvider>
    </SmokeballProvider>
  </DemoGate>
);

export { Embedded };
